import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VSwitch,_vm._g(_vm._b({attrs:{"flat":""},on:{"click":(v) => _vm.$emit('click', v)}},'v-switch',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }